import React, { useEffect, useState } from "react";
import { X, Eye, EyeOff, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export const ChangePasswordModal = ({ onClose }) => {
  const [cur, setCur] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pwd });
      toast.success("Password changed successfully");
      onClose();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Failed to change password");
    } finally { setBusy(false); }
  };

  const inputCls = "w-full px-4 py-2.5 text-sm bg-stone-50 border border-stone-200 rounded-lg focus:outline-none focus:bg-white focus:border-[#72BE44] transition";

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-white rounded-2xl p-7 w-full max-w-sm shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="change-password-modal">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-bold flex items-center gap-2" style={{ color: "#145353" }}><KeyRound className="w-4 h-4" /> Change Password</h3>
          <button onClick={onClose} className="text-stone-400 hover:text-stone-600"><X className="w-4 h-4" /></button>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="cp-current" type={show ? "text" : "password"} required value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Current password" className={inputCls} />
          <input data-testid="cp-new" type={show ? "text" : "password"} required value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="New password (min 8, letter + number)" className={inputCls} />
          <input data-testid="cp-confirm" type={show ? "text" : "password"} required value={pwd2} onChange={(e) => setPwd2(e.target.value)} placeholder="Confirm new password" className={inputCls} />
          <label className="flex items-center gap-2 text-xs text-stone-500 cursor-pointer select-none">
            <button type="button" onClick={() => setShow(!show)} className="text-stone-400">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
            {show ? "Hide" : "Show"} passwords
          </label>
          <button type="submit" disabled={busy} data-testid="cp-submit"
            className="w-full py-2.5 rounded-lg text-white font-semibold text-sm disabled:opacity-50" style={{ background: "#72BE44" }}>
            {busy ? "Saving..." : "Update Password"}
          </button>
          <p className="text-[10px] text-stone-400 text-center">You cannot reuse your last 3 passwords.</p>
        </form>
      </div>
    </div>
  );
};
